import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import { toast } from 'react-toastify';
import { FiChevronDown, FiChevronRight, FiUser } from 'react-icons/fi';

const buildTree = (employees) => {
  const map = {};
  employees.forEach(e => { map[e._id] = { ...e, children: [] }; });

  const roots = [];
  employees.forEach(e => {
    const parentId = e.reportingTo?._id || e.reportingTo;
    if (parentId && map[parentId]) {
      map[parentId].children.push(map[e._id]);
    } else {
      roots.push(map[e._id]);
    }
  });
  return roots;
};

const TreeNode = ({ node, depth = 0 }) => {
  const [expanded, setExpanded] = useState(depth < 2);
  const hasChildren = node.children.length > 0;

  return (
    <div className="hierarchy-node" style={{ marginLeft: depth === 0 ? 0 : '2rem' }}>
      <div className="hierarchy-card">
        <button
          className="hierarchy-toggle"
          onClick={() => setExpanded(v => !v)}
          style={{ visibility: hasChildren ? 'visible' : 'hidden' }}
        >
          {expanded ? <FiChevronDown /> : <FiChevronRight />}
        </button>
        <div className="hierarchy-avatar">
          {node.name.charAt(0).toUpperCase()}
        </div>
        <div className="hierarchy-info">
          <Link to={`/employees/${node._id}`} className="hierarchy-name">{node.name}</Link>
          <span className="hierarchy-meta">{node.designation} &bull; {node.department?.name}</span>
          <span className="hierarchy-id">{node.employeeId}</span>
        </div>
        {hasChildren && (
          <span className="hierarchy-count">{node.children.length} direct report{node.children.length !== 1 ? 's' : ''}</span>
        )}
      </div>
      {hasChildren && expanded && (
        <div className="hierarchy-children">
          {node.children.map(child => (
            <TreeNode key={child._id} node={child} depth={depth + 1} />
          ))}
        </div>
      )}
    </div>
  );
};

const EmployeeHierarchy = () => {
  const [tree, setTree] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/employees?limit=1000&status=Active')
      .then(res => setTree(buildTree(res.data.employees || [])))
      .catch(() => toast.error('Failed to load hierarchy'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div>
      <div className="page-header">
        <h1>Employee Hierarchy</h1>
      </div>
      <div className="hierarchy-container">
        {tree.length === 0 ? (
          <div className="empty-state"><FiUser size={32} /><p>No employees found</p></div>
        ) : (
          tree.map(node => <TreeNode key={node._id} node={node} />)
        )}
      </div>
    </div>
  );
};

export default EmployeeHierarchy;
